module.exports = __webpack_public_path__ + "img/1990_S.6961af56.png";